export default __webpack_public_path__ + "static/media/fish.75bf525e.svg";